import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { all, put, call, takeEvery } from 'redux-saga/effects';
import { deleteStatus, submitStatus, submitStatusSuccess, submitStatusFailure } from './actions';
import { convertToServerXhrPayload } from '../DaEditorWrapper/utils';
import { request } from '../xhr';
import { normalize } from '../redux/normalizr';
import { putEntities } from '../redux/entities/actions';
import { deviationSchema } from '../redux/normalizr/schemas/deviation';
import ddt from '@wix/da-ddt';
import { getDeviationUrl } from '../DeviationViews/_helpers';
import { editDeviationSuccess } from '../redux/deviations/actionCreators';
import { logBiEvent } from '../biLogger/redux/saga';
import { ResourceType } from '../types/resource';
import { PureBiData } from '@wix/da-bi/pkg/events';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        ddt.log('statusupdate', 'faking the response!');
        const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const deviation = deviationsByType.statuses[0];
        if (options.url === '/status/create' || options.url === '/status/update') {
            deviation.status.textContent = {
                excerpt: options.data.editorSnippet,
                html: {
                    type: 'draft',
                    markup: JSON.parse(options.data.editorRaw),
                    features: JSON.parse(options.data.editorFeatures)
                }
            };
        }
        return {
            deviation
        };
    }
}
function* submitStatusSaga(action) {
    var _imageDeviation;
    const { editorContent, editorRawState, features, statusId: statusid, backgroundProps = {}, refreshAfterSubmit, visibility } = action.payload;
    ddt.log('statusupdate', 'payload', action.payload);
    const isEdit = statusid !== undefined;
    const { backgroundType, gradient, imageDisplayMode, imageTint, pattern, imageDeviation } = backgroundProps;
    const snakeCaseBackgroundParams = {
        background_type: backgroundType,
        image_tint: imageTint,
        image_deviationid: (_imageDeviation = imageDeviation) === null || _imageDeviation === void 0 ? void 0 : _imageDeviation.deviationId,
        image_display_mode: imageDisplayMode,
        gradient: gradient,
        pattern: pattern
    };
    const data = _object_spread_props(_object_spread({}, convertToServerXhrPayload(editorRawState, editorContent, features), snakeCaseBackgroundParams), {
        statusid
    });
    const method = 'post';
    const url = isEdit ? '/status/update' : '/status/create';
    ddt.log('statusupdate', 'request', _object_spread_props(_object_spread({}, data), {
        url
    }));
    const result = yield call(request, {
        method,
        url,
        data
    }, fakeResponse);
    ddt.log('statusupdate', 'response', result);
    if (result && !result.error) {
        var _visibility;
        // After save we have to publish it
        const publishData = {
            statusid: result.deviation.deviationId,
            tiers: ((_visibility = visibility) === null || _visibility === void 0 ? void 0 : _visibility.type) === 'tier' ? visibility.tiers.map((tier)=>tier.deviationId) : undefined
        };
        const publishResult = yield call(request, {
            method: 'post',
            url: '/status/publish',
            data: publishData
        }, fakeResponse);
        ddt.log('statusupdate', 'response publish', publishResult);
        if (!publishResult || publishResult.error) {
            var _result, _result1;
            if (result && result.errorCode === 302) {
                window.location.replace(result.errorDetails.redirectUrl);
            }
            yield put(submitStatusFailure({
                error: (_result = result) === null || _result === void 0 ? void 0 : _result.error_description
            }));
            ddt.log('statusupdate', 'failure', (_result1 = result) === null || _result1 === void 0 ? void 0 : _result1.error_description);
        }
        const { result: statusId, entities } = normalize(publishResult.deviation, deviationSchema);
        if (!isEdit) {
            yield call(logBiEvent, PureBiData({
                evid: 11,
                group_exclusive: false,
                itemid: publishResult.deviation.deviationId,
                typeid: ResourceType.STATUS_DEVIATION
            }));
        }
        const resultActions = [
            put(putEntities({
                entities
            })),
            // The statusId returned from normalize will be a string, but this expects a non-normalized ID, so pull straight from the result
            put(submitStatusSuccess({
                statusId: publishResult.deviation.deviationId
            }))
        ];
        if (isEdit) {
            resultActions.push(put(editDeviationSuccess({
                deviation: publishResult.deviation
            })));
        }
        yield all(resultActions);
        ddt.log('statusupdate', 'success', statusId);
        // redirect
        if (refreshAfterSubmit) {
            window.location.reload();
        } else {
            const deviation = publishResult.deviation;
            window.location.assign(getDeviationUrl(deviation));
        }
    } else {
        var _result2, _result3;
        if (result && result.errorCode === 302) {
            window.location.replace(result.errorDetails.redirectUrl);
        }
        yield put(submitStatusFailure({
            error: (_result2 = result) === null || _result2 === void 0 ? void 0 : _result2.error_description
        }));
        ddt.log('statusupdate', 'failure', (_result3 = result) === null || _result3 === void 0 ? void 0 : _result3.error_description);
    }
}
function* deleteStatusSaga(action) {
    const { statusId: statusid } = action.payload;
    ddt.log('statusupdate', 'deleting', statusid);
    const result = yield call(request, {
        method: 'post',
        url: `/status/delete`,
        data: {
            statusid
        }
    }, fakeResponse);
    ddt.log('statusupdate', 'response', result);
}
export default function* saga() {
    yield all([
        takeEvery(submitStatus, submitStatusSaga),
        takeEvery(deleteStatus, deleteStatusSaga)
    ]);
}
